<template>
    <div class="liai-1">
        <div class="block">
            <!-- v-if="activities.length > 0" -->
            <div class="liaMan">
                <div class="timeTop">
                    <div class="timeColor">
                        <span class="color color1"></span>
                        <span class="colorName">呼入</span>
                        <span class="color color2"></span>
                        <span class="colorName">呼出</span>
                    </div>
                    <p class="choose">
                        <span
                            :class="statisticsStatus == 3 ? 'cur' : ''"
                            @click="tapChoose(3)"
                            >月</span
                        >
                        <span
                            :class="statisticsStatus == 2 ? 'cur' : ''"
                            @click="tapChoose(2)"
                            >季度</span
                        >
                        <span
                            :class="statisticsStatus == 1 ? 'cur' : ''"
                            @click="tapChoose(1)"
                            >年</span
                        >
                    </p>
                </div>
                <div class="timeContente" v-if="activities.length > 0">
                    <div
                        class="tiemItem"
                        v-for="(activity, index) in activities"
                        :key="index"
                    >
                        <div class="timeTap">
                            <div
                                v-for="(it, ind) in activity.callInfoList"
                                :key="ind"
                                class="historyItem"
                            >
                                <p class="moneyName">
                                    <span
                                        v-if="activity.month == '01'"
                                        :class="
                                            activity.month == '01'
                                                ? 'month1'
                                                : ''
                                        "
                                        >{{ activity.month }}</span
                                    >
                                    <span
                                        v-if="activity.month == '02'"
                                        :class="
                                            activity.month == '02'
                                                ? 'month2'
                                                : ''
                                        "
                                        >{{ activity.month }}</span
                                    >
                                    <span
                                        v-if="activity.month == '03'"
                                        :class="
                                            activity.month == '03'
                                                ? 'month3'
                                                : ''
                                        "
                                        >{{ activity.month }}</span
                                    >
                                    <span
                                        v-if="activity.month == '04'"
                                        :class="
                                            activity.month == '04'
                                                ? 'month4'
                                                : ''
                                        "
                                        >{{ activity.month }}</span
                                    >
                                    <span
                                        v-if="activity.month == '05'"
                                        :class="
                                            activity.month == '05'
                                                ? 'month5'
                                                : ''
                                        "
                                        >{{ activity.month }}</span
                                    >
                                    <span
                                        v-if="activity.month == '06'"
                                        :class="
                                            activity.month == '06'
                                                ? 'month6'
                                                : ''
                                        "
                                        >{{ activity.month }}</span
                                    >
                                    <span
                                        v-if="activity.month == '07'"
                                        :class="
                                            activity.month == '07'
                                                ? 'month7'
                                                : ''
                                        "
                                        >{{ activity.month }}</span
                                    >
                                    <span
                                        v-if="activity.month == '08'"
                                        :class="
                                            activity.month == '08'
                                                ? 'month8'
                                                : ''
                                        "
                                        >{{ activity.month }}</span
                                    >
                                    <span
                                        v-if="activity.month == '09'"
                                        :class="
                                            activity.month == '09'
                                                ? 'month9'
                                                : ''
                                        "
                                        >{{ activity.month }}</span
                                    >
                                    <span
                                        v-if="activity.month == '10'"
                                        :class="
                                            activity.month == '10'
                                                ? 'month10'
                                                : ''
                                        "
                                        >{{ activity.month }}</span
                                    >
                                    <span
                                        v-if="activity.month == '11'"
                                        :class="
                                            activity.month == '11'
                                                ? 'month11'
                                                : ''
                                        "
                                        >{{ activity.month }}</span
                                    >
                                    <span
                                        v-if="activity.month == '12'"
                                        :class="
                                            activity.month == '12'
                                                ? 'month12'
                                                : ''
                                        "
                                        >{{ activity.month }}</span
                                    >
                                </p>
                                <div class="callTitle">
                                    <p
                                        class="line"
                                        :class="
                                            it.outCall == '0'
                                                ? 'incall'
                                                : 'outcall'
                                        "
                                    ></p>
                                    <p
                                        class="name"
                                        :class="
                                            it.outCall == '0'
                                                ? 'incall'
                                                : 'outcall'
                                        "
                                    >
                                        {{ it.startTime.substring(8, 10) }}
                                    </p>
                                </div>
                                <div class="flexRight">
                                    <p
                                        class="typeClass"
                                        :class="
                                            it.outCall == '0'
                                                ? 'incall'
                                                : 'outcall'
                                        "
                                    >
                                        沟通类型：{{ it.callTypeDes }}
                                    </p>
                                </div>
                                <div class="flexRight">
                                    <p
                                        class="typeClass"
                                        v-if="it.remark"
                                        :class="
                                            it.outCall == '0'
                                                ? 'incall'
                                                : 'outcall'
                                        "
                                    >
                                        呼叫小结：{{ it.remark }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <el-timeline>
                        <el-timeline-item
                            placement="top"
                            v-for="(activity, index) in activities"
                            :key="index"
                            type="primary"
                            :timestamp="activity.connectTime"
                            v-if="
                                !(
                                    activity.callTypeDes == null &&
                                    activity.remark == null
                                )
                            "
                        >
                            <el-card
                                :class="
                                    activity.outCall == 0
                                        ? 'change1'
                                        : 'change2'
                                "
                                class="card-color"
                            >
                                <div class="list-1">
                                    呼叫号码：{{ activity.remoteNum }}
                                </div>
                                <div class="list-2">
                                    <span
                                        >沟通类型：{{
                                            activity.callTypeDes
                                        }}</span
                                    >
                                    <span
                                        >呼叫类型：{{
                                            activity.outCall == 0
                                                ? "呼入"
                                                : "呼出"
                                        }}</span
                                    >
                                </div>
                                <div class="list-2">
                                    呼叫小结：{{ activity.remark }}
                                </div>
                            </el-card>
                        </el-timeline-item>
                    </el-timeline> -->
                </div>
            </div>

            <!-- <div v-else>无对应记录</div> -->
        </div>
    </div>
</template>

<script>
import request from "@/utils/request.js"
export default {
    props: {
        formData: {},
    },
    data() {
        return {
            activities: [],
            statisticsStatus: 3,
        }
    },
    watch: {
        formData: {
            handler(val) {
                if (this.formData.phone) {
                    this.getList()
                }
                if (val.hide) {
                    this.activities = []
                }
            },
            deep: true,
            immediate: true,
        },
    },
    mounted() {},
    methods: {
        // 切换筛选
        tapChoose(index) {
            this.statisticsStatus = index
            this.getList()
        },
        // 列表数据
        getList() {
            const self = this

            request({
                url: "/jjyl/traffic/callInfo/info/findListForSummary",
                method: "POST",
                data: {
                    pageNo: 1,
                    pageSize: 9999,
                    statisticsStatus: self.statisticsStatus,
                    phone: self.formData.phone,
                    // phone: "13955063192",
                },
            }).then((res) => {
                if (res.code === 200 && res.content) {
                    const arr = res.content || []
                    console.log("联络历史", arr)
                    this.activities = []
                    if (arr.length > 0) {
                        arr.forEach((item) => {
                            if (item.callInfoList.length != 0) {
                                this.activities.push(item)
                            }
                        })

                        console.log(this.activities, "联络数据")
                    }
                } else {
                    this.activities = []
                }
            })
        },
    },
}
</script>

<style lang="less" scoped>
.liai-1 {
    width: 98%;
    margin-left: 2%;
}

.card-color {
    color: #ffffff;
}

.change1 {
    background-color: #75b1cc;
}

.change2 {
    background-color: #086f9e;
}

.list-1 {
    height: 26px;
    border-bottom: 1px solid #ffffff;
}

.list-2 {
    height: 36px;
    line-height: 36px;
    border-bottom: 1px solid #ffffff;
    span {
        margin-right: 20px;
    }
}

.list-3 {
    margin-top: 10px;
}

.title1 {
    /deep/ .el-timeline-item__timestamp {
        color: #6cbfee;
        font-size: 16px;
        font-weight: bold;
    }
}
.liaMan {
    width: 500px;
}
.title2 {
    /deep/ .el-timeline-item__timestamp {
        color: #3594cb;
        font-size: 16px;
        font-weight: bold;
    }
}
.timeTop {
    margin-bottom: 15px;
    // margin-right: 200px;
    display: flex;
    justify-content: center;
    align-content: center;
    .timeColor {
        flex: 1;
        padding-left: 140px;
        font-size: 12px;
        line-height: 22px;
        .color {
            display: inline-block;
            width: 8px;
            height: 8px;
            margin-right: 8px;
            border-radius: 50%;
            &.color1 {
                background: #01b1ff;
            }
            &.color2 {
                background: #88c8ff;
            }
        }
        .colorName {
            margin-right: 20px;
        }
    }
    .choose {
        cursor: pointer;
        color: #fff;
        span {
            display: inline-block;
            border-radius: 4px;
            padding: 0px 12px;
            &.cur {
                background: #1ab394;
            }
        }
        border-radius: 4px;
        line-height: 22px;
        background: #d5d5d5;
    }
}
/deep/.el-timeline-item__timestamp {
    color: #75b1cc;
    font-size: 14px;
}
.timeContente {
    height: 600px;
    // padding: 0 240px 0 140px;
    padding: 0 40px;
    overflow: scroll;
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
}
.timeContente::-webkit-scrollbar {
    display: none;
}
.timeTap {
    border-left: 3px solid #bababa;
    padding: 15px 0;

    .moneyName {
        position: absolute;
        span {
            width: 40px;
            position: relative;
            left: -20px;
            text-align: center;
            display: inline-block;
            color: #fff;
            height: 40px;
            line-height: 40px;
            border-radius: 50%;
            &.month1 {
                background: #ff6172;
            }
            &.month2 {
                background: #2d9fe8;
            }
            &.month3 {
                background: #ffaf57;
            }
            &.month4 {
                background: #19c8a5;
            }
            &.month5 {
                background: #ff60d4;
            }
            &.month6 {
                background: #47edef;
            }
            &.month7 {
                background: #5890ff;
            }
            &.month8 {
                background: #01b1ff;
            }
            &.month9 {
                background: #fa7093;
            }
            &.month10 {
                background: #ffc001;
            }
            &.month11 {
                background: #4ce26f;
            }
            &.month12 {
                background: #6455ed;
            }
        }
    }
    .callTitle {
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: 40px;
        font-size: 14px;
        color: #fff;
        .line {
            height: 3px;
            flex: 1;
        }
        .name {
            width: 40px;
            text-align: center;
            height: 40px;
            border-radius: 50%;
        }
    }
    .flexRight {
        display: flex;
        justify-content: flex-end;
        margin-left: 40px;

        .typeClass {
            margin: 15px 0;
            font-size: 14px;
            line-height: 24px;
            padding: 5px 10px;
            border-radius: 6px;
            color: #fff;
        }
    }
}
.incall {
    background: #01b1ff;
}
.outcall {
    background: #88c8ff;
}
.historyItem {
    position: relative;
}
</style>
